import { Input } from "@/app/admin/_common/ui/input";
import { Search } from "lucide-react";

export default function LocationsToolbar({
  search,
  onSearchChange,
}: {
  search: string;
  onSearchChange: (value: string) => void;
}) {
  return (
    <div className="relative max-w-[420px]">
      <div className="pointer-events-none absolute inset-y-0 left-3 flex items-center">
        <Search className="size-3.5 text-muted-foreground" />
      </div>
      <Input
        type="search"
        placeholder="Search locations…"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        className="h-[30px] pl-9 text-[12.5px]"
        aria-label="Search locations"
      />
    </div>
  );
}
